var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0572 2.5H6.66667C6.29847 2.5 6 2.79847 6 3.16667V29.1667C6 29.5349 6.29847 29.8333 6.66667 29.8333H26C26.3682 29.8333 26.6667 29.5349 26.6667 29.1667V9.10947C26.6667 8.93267 26.5964 8.7631 26.4714 8.63807L20.5286 2.69527C20.4036 2.57023 20.234 2.5 20.0572 2.5Z",
    fill: "white",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.83301V8.83301C20 9.20121 20.2985 9.49967 20.6667 9.49967H26.6667",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 25.5H8.4C8.73137 25.5 9 25.2314 9 24.9V20.1C9 19.7686 8.73137 19.5 8.4 19.5H3.6C3.26864 19.5 3 19.7686 3 20.1V24.9C3 25.2314 3.26864 25.5 3.6 25.5Z",
    fill: "#D65532"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 25.5H29.4C29.7314 25.5 30 25.2314 30 24.9V20.1C30 19.7686 29.7314 19.5 29.4 19.5H24.6C24.2686 19.5 24 19.7686 24 20.1V24.9C24 25.2314 24.2686 25.5 24.6 25.5Z",
    fill: "#D65532"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 26H12.1C11.8905 26 11.721 25.9375 11.6163 25.8613C11.511 25.7848 11.5 25.7215 11.5 25.7V19.3C11.5 19.2785 11.511 19.2152 11.6163 19.1387C11.721 19.0625 11.8905 19 12.1 19H20.9C21.1095 19 21.279 19.0625 21.3837 19.1387C21.489 19.2152 21.5 19.2785 21.5 19.3V25.7C21.5 25.7215 21.489 25.7848 21.3837 25.8613C21.279 25.9375 21.1095 26 20.9 26Z",
    stroke: "#D65532"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8542 15.5H19.3333H13.8438H9.32292C9.1446 15.5 9 15.6446 9 15.8229C9 16.0013 9.1446 16.1458 9.32292 16.1458H13.8438H19.3333H23.8542C24.0325 16.1458 24.1771 16.0013 24.1771 15.8229C24.1771 15.6446 24.0325 15.5 23.8542 15.5Z",
    fill: "#D1CCC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8542 13.5H19.3333H13.8438H9.32292C9.1446 13.5 9 13.6446 9 13.8229C9 14.0013 9.1446 14.1458 9.32292 14.1458H13.8438H19.3333H23.8542C24.0325 14.1458 24.1771 14.0013 24.1771 13.8229C24.1771 13.6446 24.0325 13.5 23.8542 13.5Z",
    fill: "#D1CCC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfx);
export default __webpack_public_path__ + "static/media/pdfx.ac40a249.svg";
export { ForwardRef as ReactComponent };